// extracted by mini-css-extract-plugin
module.exports = {"button":"InstagramAccountVerified_button__uApNy"};